import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "avatar-stack position-relative d-flex" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { style: {"font-size":"var(--font-xxs)","font-weight":"500","letter-spacing":"-1px"} }
const _hoisted_4 = { style: {"font-size":"var(--font-xxs)","font-weight":"500"} }

import { computed } from 'vue';

import { getColorByStaffId } from '@/lib/utils';
import type { Member } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AvatarStack',
  props: {
    avatarList: {},
    maxVisible: {}
  },
  setup(__props: any) {

const props = __props;

const MAX_VISIBLE_AVATARS = computed(() => props.maxVisible ?? 3);

const visibleAvatars = computed<Member[]>(() => {
  return props.avatarList.slice(0, MAX_VISIBLE_AVATARS.value);
});

const overflowCount = computed<number>(() => {
  return props.avatarList.length - MAX_VISIBLE_AVATARS.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleAvatars.value, (avatar, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: avatar.id,
        style: _normalizeStyle({ zIndex: index, transform: `translateX(${index * -0.5}rem)` })
      }, [
        (avatar?.avatarUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: avatar?.avatarUrl,
              alt: `${avatar.firstname}-${avatar.lastname}-avatar`,
              class: "avatar",
              style: _normalizeStyle({ backgroundColor: _unref(getColorByStaffId)(avatar.id) })
            }, null, 12, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "avatar flex-center",
              style: _normalizeStyle({ background: _unref(getColorByStaffId)(avatar?.id) })
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(avatar?.firstName ? avatar.firstName.charAt(0).toUpperCase() : avatar?.name?.trim().split(/\s+/)[0]?.charAt(0).toUpperCase() ?? '') + " " + _toDisplayString(avatar?.lastName ? avatar.lastName.charAt(0).toUpperCase() : avatar?.name?.trim().split(/\s+/)[1]?.charAt(0).toUpperCase() ?? ''), 1)
            ], 4))
      ], 4))
    }), 128)),
    (overflowCount.value > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "overflow-badge flex-center",
          style: _normalizeStyle({ 
        transform: `translateX(${visibleAvatars.value.length * -0.5}rem)`, 
        zIndex: visibleAvatars.value.length, 
      })
        }, [
          _createElementVNode("span", _hoisted_4, "+" + _toDisplayString(overflowCount.value), 1)
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})